export { default } from "./withHoverStateLabel";
